import {
	includedPropList,
	includedT2PropList,
} from "../../../pages/activityBuilder/modules/waterbodies/waterbodies";
import type {
	ModuleFull,
	WaterbodiesResponse,
} from "../../../pages/activityBuilder/modules/waterbodies/waterbodiesTypes";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";

// Define constants for the module
const MODULE_TYPE = "Waterbodies";
const TAG: TagTypes = "Waterbodies";
const TAG_DEFAULTS: TagTypes = "WaterbodiesDefaults";
const ENDPOINT = FEModulesObj[FEModules.Waterbodies].path;

const transformResponse = (response: WaterbodiesResponse) => transformModuleResponse<WaterbodiesResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList
})

const waterbodiesApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicWaterbodiesApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, WaterbodiesResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
	includesLandUseChange: true
})

export const {
	useGetWaterbodiesQuery,
	useGetWaterbodiesDefaultsQuery
} = waterbodiesApiSlice;

export const {
	useGetWaterbodiesQuery: usePublicGetWaterbodiesQuery,
	useGetWaterbodiesDefaultsQuery: usePublicGetWaterbodiesDefaultsQuery
} = publicWaterbodiesApiSlice;

export const {
	useUpdateWaterbodiesMutation,
} = mutationApiSlice;
